import styled from 'styled-components';

import { CustomIconProps } from '@components/utils/CustomIcon';

const IconWrapper = styled.span`
  line-height: 0;
  vertical-align: -0.125em;
  display: inline-block;
`;

export const Icon = ({ icon: Icon, ...params }: CustomIconProps) => {
  return (
    <IconWrapper>
      <Icon width='1em' height='1em' {...params} />
    </IconWrapper>
  );
};
